import styled from "styled-components";

export const Flex = styled.div`
    flex: 1;
    display: flex;
`;